import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FOLDERS } from "../domain";
import { ACTION_GET_FOLDER } from "../GetFolder/useGetFolder";

import { foldersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DELETE_FOLDER = "DELETE_FOLDER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteFolder = async (folderId: string): Promise<void> => {
  await foldersApi.foldersControllerDeleteFolder(folderId);
};

export const useDeleteFolder = (
  user: UserProfileDto | null,
): {
  deleteFolderAsync: UseMutateFunction<void, Error, string, unknown>;
  deleteFolderEnabled: boolean;
  isSuccessFolder: boolean;
  isPendingFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FOLDERS, ACTION_DELETE_FOLDER],
    mutationFn: enabled ? deleteFolder : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    deleteFolderAsync: mutateAsync,
    deleteFolderEnabled: enabled,
    isSuccessFolder: isSuccess,
    isPendingFolder: isPending,
  };
};
